var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigninEmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40332 7.0606L11.9997 11.8582L21.5961 7.0606C21.5606 6.44914 21.2926 5.87439 20.8471 5.45408C20.4016 5.03376 19.8122 4.79969 19.1997 4.7998H4.79972C4.18722 4.79969 3.59786 5.03376 3.15233 5.45408C2.70681 5.87439 2.43885 6.44914 2.40332 7.0606Z",
    fill: "#17BAB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6004 9.7417L12.0004 14.5417L2.40039 9.7417V16.8001C2.40039 17.4366 2.65325 18.0471 3.10333 18.4972C3.55342 18.9472 4.16387 19.2001 4.80039 19.2001H19.2004C19.8369 19.2001 20.4474 18.9472 20.8974 18.4972C21.3475 18.0471 21.6004 17.4366 21.6004 16.8001V9.7417Z",
    fill: "#17BAB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninEmailLogo);
export default __webpack_public_path__ + "static/media/signin_email_logo.d49d877f5f8291bbbcd83993e8294582.svg";
export { ForwardRef as ReactComponent };